// Module
var code = "<a href=\"javascript:;\" ng-href=\"{{::$ctrl.videoUrl | toOneDomain }}\"> <div class=\"support-video-thumbnail__play\"></div> <img src=\"/components/design/content/blank.png\" ng-src=\"{{::$ctrl.videoThumbnailSrc}}\"/> </a>";
// Exports
module.exports = code;